import React from 'react';
import {
  Divider,
  Flex,
  PrimaryButton,
  RemoteImage,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import { isNil } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';
import { useAiStudioProductInfo } from '../queries/useAiStudioProductInfo';
import { useGoodsBasic } from '../../../../../queries/useGoodsBasic';

// 네이티브 ProductDetailAiProductCell 대응.
// (상단 타이틀 + 이미지 최대 3장 + "AI가 찍어준 내모습 보러가기" 버튼 → deeplink)
const MAX_IMAGES = 3;
const HORIZONTAL_PADDING = 16;
const IMAGE_GAP = 4; // SpacingSize 토큰 (네이티브 spacing 3 근사)

export const AiProduct: React.FC<{
  onChangeHeight: (height: number) => void;
}> = props => {
  const { data } = useAiStudioProductInfo();
  const { data: goodsBasic } = useGoodsBasic();
  const { openDeeplink } = useOpenDeeplink();
  const { width } = useScreenSize();

  const marketName = goodsBasic?.market.name ?? '';

  // 네이티브: aiStudioProductInfo 있고 이미지 있을 때만 노출. 없으면 렌더 X(높이 0 유지).
  if (isNil(data)) return null;
  const images = data.details.slice(0, MAX_IMAGES);
  if (images.length === 0) return null;

  // TODO(디자인): 네이티브 셀 스펙(높이 275 / 이미지 130 / cornerRadius 4)에 맞춰 조정.
  const imageSize =
    (width - HORIZONTAL_PADDING * 2 - IMAGE_GAP * (images.length - 1)) /
    images.length;

  const onPressButton = () => {
    if (isNil(data.deeplink)) return;
    // TODO(로깅): 네이티브 AI 상품 탭 이벤트명 확인 후 로깅 추가
    //   (logging-events.md 동기화 필요)
    openDeeplink(data.deeplink);
  };

  return (
    <Flex
      onLayout={({ nativeEvent }) => {
        props.onChangeHeight(nativeEvent.layout.height);
      }}
    >
      <Divider size={'small'} />
      {/* 네이티브: "내가 {마켓명} 모델이라면?" — 마켓명만 pink 강조 (API title 아님) */}
      <Flex padding={{ horizontal: HORIZONTAL_PADDING, top: 24, bottom: 16 }}>
        <Typography type={'h5'} color={'content_primary'}>
          {'내가 '}
          <Typography type={'h5'} color={'content_pink_primary'}>
            {marketName}
          </Typography>
          {' 모델이라면?'}
        </Typography>
      </Flex>

      <Flex.Row
        padding={{ horizontal: HORIZONTAL_PADDING }}
        columnGap={IMAGE_GAP}
      >
        {images.map((uri, index) => (
          <RemoteImage
            key={`ai-product-${index}`}
            uri={uri}
            width={imageSize}
            height={imageSize}
            borderRadius={'xsmall'}
          />
        ))}
      </Flex.Row>

      <Flex padding={{ horizontal: HORIZONTAL_PADDING, top: 16, bottom: 24 }}>
        <PrimaryButton
          color={'gray'}
          size={'large'}
          variant={'fill'}
          outline
          onPress={onPressButton}
          // leftIcon={Icon}
        >
          {'AI가 찍어준 내모습 보러가기'}
        </PrimaryButton>
      </Flex>
    </Flex>
  );
};
